import classNames from 'classnames';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import './navigation-arrows.scss';

const NavigationArrows = ({ hasPreviousPage, hasNextPage, onPreviousPageClick, onNextPageClick }) => {
  return (
    <div className="navigation-arrows__navigation">
      <div
        onClick={() => {
          hasPreviousPage && onPreviousPageClick();
        }}
        className={classNames('navigation-arrows__prev-item', {
          'navigation-arrows__prev-item--disabled': !hasPreviousPage,
        })}
      >
        <FiChevronLeft />
      </div>
      <div
        onClick={() => {
          hasNextPage && onNextPageClick();
        }}
        className={classNames('navigation-arrows__next-item', {
          'navigation-arrows__next-item--disabled': !hasNextPage,
        })}
      >
        <FiChevronRight />
      </div>
    </div>
  );
};

export default NavigationArrows;
